export enum InternalLinksEnum {
    EXTENSION = 'https://chromewebstore.google.com/detail/giftmio-extension/jndboabnjeeeepiipnmjnpcbgjpffikm',
    EXTENSION_LANDING = 'https://extension.giftmio.com',
    DEVELOPERS_RU = 'https://developers.giftmio.com/ru/',
    DEVELOPERS_EN = 'https://developers.giftmio.com/en/',
}
